module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_SLOE_W_VSL2100_VERTICALE.a4d7a861.png";